<template>
	<div v-bind:class="getMainClass()" v-bind:style="getMainStyle()" ref="main">
		<slot></slot>
	</div>
</template>
<script>

export default {
	props:{
		locked:Boolean,
		bg:String,
		viewWindow:Number,
	},
	computed: {
		deviceType:function(){
			return this.$store.state.device.type;
		},
		scrollTop:function(){
			return this.$store.state.scroll.top;
		}
	},
	created:function(){
		if (this.viewWindow){
			this.$store.dispatch('SCROLL_MARGIN_TOP_SET',{device:this.deviceType,viewWindow:this.viewWindow});
		}
	},
	data:function(){
		return {
			scrolling:false
		};
	},
	methods:{
		getMainClass:function(){
			let cl = 'content-body flex-2';
			if (this.deviceType !== 'mobile'){
				this.scrolling = true;
				cl += ' scroll-y';
			} else {
				this.scrolling = false;
			}
			if (this.locked) cl += ' locked';
			return cl;
		},
		getMainStyle:function(){
			let st = '';
			if (this.bg) st += 'background-color:'+this.bg+';';
			return st;
		}
	},
	watch:{
		scrollTop:function(scrollNew){
			if (scrollNew === -1) return;

			if (this.scrolling){
				this.$refs['main'].scrollTo(0,scrollNew);
				this.$store.dispatch('SCROLL_TOP_RESET',-1);
			}
			
		}
	}
}
</script>
<style>
	.content-body{
		background-color:#FFFFFF;
		width:100%;
		min-height:100px;
		position:relative;
		z-index:900;
	}
</style>


// WEBPACK FOOTER //
// src/components/content/content-body.vue